import { gql } from "@/gql/__generated__";
import { useQuery } from "@apollo/client";

const APP = gql(`
  query APP($organizationSlug: String!, $appSlug: String!) {
    app(organizationSlug: $organizationSlug, appSlug: $appSlug) {
      ... on App {
        id
        defaultDeployment { ... DeploymentFragment }
      }
    }
  }

  fragment DeploymentFragment on AppDeployment {
    __typename
    id
    current {
      __typename
      id
      status
      proxyURL
      appVersion {
        releaseNotes {
          filename
          contentBase64
        }
        userGuide {
          filename
          contentBase64
        }
      }
    }
  }
`);

export function useApp({
  organizationSlug,
  appSlug
}: {
  organizationSlug: string;
  appSlug: string;
}) {
  return useQuery(APP, {
    variables: { organizationSlug, appSlug }
  });
}
